(() => {
  const OPEN_CLASS = 'is-visible';
  const POLL_MS = 300;

  const isOpen = () =>
    [...document.querySelectorAll('cart-drawer')].some(
      el => el.isConnected && el.classList.contains(OPEN_CLASS)
    );

  customElements.whenDefined('newsletter-popup').then(() => {
    const NewsletterPopup = customElements.get('newsletter-popup');
    const originalShow = NewsletterPopup.prototype.show;
    if (typeof originalShow !== 'function') return;

    NewsletterPopup.prototype.show = function (...args) {
      if (!isOpen()) return originalShow.apply(this, args);
      if (this._cartGuardPending) return;

      this._cartGuardPending = true;

      const poll = setInterval(() => {
        if (isOpen()) return;
        clearInterval(poll);
        this._cartGuardPending = false;
        if (this.closed === 'true' || this.subscribed === 'true') return;
        originalShow.apply(this, args);
      }, POLL_MS);
    };
  });
})();